import { finish, error } from '../../../modules/documents/actions/documents';

import api from '../../../api';

export function getDocument(dispatch, { documentId, format, title }) {
    let data = {
        documentId,
        format
    };

    let headers = {
        'csv': 'text/csv'
    };

    api.get('/documents', data, {
        headers: {
            'Accept': headers[format]
        }
    }).then(
        (content) => { finish(format, title, content) },
        ({ errors }) => dispatch(error(errors))
    );
}
